import { render, staticRenderFns } from "./TheModal.vue?vue&type=template&id=41f460d8&"
import script from "./TheModal.vue?vue&type=script&lang=ts&"
export * from "./TheModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports